import * as React from "react";
import { Button } from "@material-ui/core";
import { BsArrowLeft } from "react-icons/bs";
import EventHelper from "common/helpers/eventHelper/eventHelper";
import { changeUrl } from "common/history";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { useEventControlStyles } from "./eventControlStyles";

export default function BackToMyPicks() {
	const styles = useEventControlStyles();

	const backToMyPicks = () => {
		changeUrl(GetCurrentGamePrefix() + "/event/" + EventHelper.currentEventId);
	};

	return (
		<Button
			className={styles.action}
			startIcon={<BsArrowLeft />}
			onClick={backToMyPicks}
		>
			Back to my picks
		</Button>
	);
}
